// react
import { useEffect } from 'react';

// context hooks
import useAsp from 'hooks/useAsp';

// types
//import { OrderType } from 'types/order';
import { useLocation } from 'react-router-dom';

const MfroTag = () => {
  const { isThanks } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'mfro';
    const scriptClassName = 'mfro-load';
    const isExistScript = document.getElementById(scriptId);
    const isExistLoadScript = document.getElementsByClassName(scriptClassName);
    if (!!isExistScript) isExistScript.remove();
    if (isExistLoadScript.length) isExistLoadScript[0].remove();
    //const orderCode = order ? (order as OrderType).order_code : '';
    const script = document.createElement('script');
    script.id = scriptId;
    script.innerHTML = isThanks
      ? ``
      : `
  (function(){
    var uqid = "5dae53Dceda2XD48";
    var cid  = "690";

    var a=document.createElement("script");
    a.dataset.uqid=uqid;a.dataset.cid=cid;a.id="afadfpc-"+Date.now();
    a.src="//ad.mtrf.net/fpc/cookie_js.php?scriptId="+encodeURIComponent(a.id);
    document.body.appendChild(a);
    })();
      `;
    document.body.appendChild(script);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return <></>;
};

export default MfroTag;
